import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import {
  ChangePwd,
  EditProfileBody,
  HttpResponse,
  ProfileDetail,
} from "../interfaces";
import { CommonWebService } from "../public-api";
import { UserHttpService } from "./user-session.service";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  constructor(
    private http: HttpClient,
    private userSessionService: UserHttpService,
    private commonWebService: CommonWebService
  ) {}

  //save notification detail
  public saveNotificationDetail(
    notification_preference: string
  ): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("notification_preference", notification_preference);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any>>("setting/preferences/", formData);
  }

  //save notification detail
  public getNotificationDetail(): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any>>("setting/preferences/getpreference", formData);
  }

  //change pwd
  public authChangePwd(body: ChangePwd): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("current_password", body.current_password);
    formData.append("new_password", body.new_password);
    formData.append("confirm_password", body.confirm_password);
    return this.http.post<HttpResponse<any>>("setting/changePassword/", formData);
  }

  //get profile detail
  public getProfileDetail(): Observable<HttpResponse<ProfileDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<ProfileDetail[]>>("setting/profile", formData).pipe(
      map((response) => {
        if(response && response.data && response.data[0]) {
          response.data[0].usr_dob = response.data[0].usr_dob && response.data[0].usr_dob !== '0000-00-00' ? response.data[0].usr_dob : '';
          response.data[0].aniversary = response.data[0].aniversary && response.data[0].aniversary !== '0000-00-00' ? response.data[0].aniversary : '';
          response.data[0].joining = response.data[0].usr_dob && response.data[0].joining !== '0000-00-00' ? response.data[0].joining : '';
          return response;
        } else {
          return response
        }
      })
    );
  }

  //save profile detail
  saveProfileDetail(body: EditProfileBody, isProfileChange: boolean, isIdProofChange: boolean): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("user_first_name", body.user_first_name);
    formData.append("user_last_name", body.user_last_name);
    formData.append("role", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("manager_id", body.manager_id ? body.manager_id : 'undefined');
    formData.append("emp_id", body.emp_id ? body.emp_id : 'undefined');
    formData.append("user_designation", body.user_designation ? body.user_designation : '');
    formData.append("dojoining", this.commonWebService.changeDateFormat(body.dojoining) ? this.commonWebService.changeDateFormat(body.dojoining) : '');
    formData.append("user_mobile", body.user_mobile ? body.user_mobile : '');
    formData.append("user_email", body.user_email ? body.user_email : '');
    formData.append("user_skypeid", body.user_skypeid ? body.user_skypeid : '');
    formData.append("doBirth", body.doBirth ? this.commonWebService.changeDateFormat(body.doBirth) : '');
    formData.append("doanniversary", body.doanniversary ? this.commonWebService.changeDateFormat(body.doanniversary) : '');
    formData.append("address", body.address ? body.address : '');
    formData.append("address2", body.address2 ? body.address2 : "");
    formData.append("country", body.country ? body.country : '');
    formData.append("state", body.state ? body.state : '');
    formData.append("city", body.city ? body.city : '');
    formData.append("zipcode", body.zipcode ? body.zipcode : '');
    formData.append("user_department", body.user_department ? body.user_department : '');
    formData.append("token", this.userSessionService.userToken);
    formData.append("profile_picture", !isProfileChange ? this.commonWebService.getFormattedImageBase64(body.profile_picture) : '');
    formData.append("id_proof", !isIdProofChange ? this.commonWebService.getFormattedImageBase64(body.id_proof) : '');

    return this.http.post<HttpResponse<any>>("setting/profile/profileUpdate", formData);
  }

}
